class RemoveExclusiveProducts extends HTMLElement {
  connectedCallback() {
    try {
      this.exclusiveVariants = JSON.parse(this.dataset.exclusiveVariants);
    } catch (err) {
      this.exclusiveVariants = [];
    }
    this.removeExclusiveProducts();
  }

  removeExclusiveProducts() {
    if (!this.exclusiveVariants.length) {
      return;
    }

    fetch(
      window.Shopify.routes.root +
        `cart/update.js?sections=cart-drawer,cart-icon-bubble&sections_url=${window.location.pathname}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: this.exclusiveVariants.reduce((acc, variantId) => ({ ...acc, [variantId]: 0 }), {}),
        }),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((parsedState) => {
        if (parsedState.errors) {
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'remove-exclusive-products',
          cartData: parsedState,
        });
        const cart = document.querySelector('cart-drawer');
        cart?.renderContents(parsedState, { shouldOpen: false });
        publish(PUB_SUB_EVENTS.toastOpen, {
          message: 'Perks exclusive items have been removed from your cart.',
          status: 'info',
        });
      });
  }
}

customElements.define('remove-exclusive-products', RemoveExclusiveProducts);
